import { Request } from 'commons/utils/request'
import { Page, PageFace, Panel, PanelFace } from 'ui/components'
import { ExportCSVButton } from 'ui/temp/ExportCSVButton'

import { ReportBreadcrumbs } from '../../components'
import { Filter, RelationshipsReportTable } from './components'
import { RelationshipsReportContextContextProvider } from './context/RelationshipsReportContextContextProvider'

const RelationshipsReport = () => (
  <RelationshipsReportContextContextProvider>
    <Page
      face={PageFace.PRIMARY}
      title={<ReportBreadcrumbs title="Relationships Report" />}
      actions={<ExportCSVButton reportName="Relationships" url={Request.urls.bank.portalReportRelationshipsCSV} />}
    >
      <Panel rounded shadowed collapsible={false} face={PanelFace.SECONDARY}>
        <Filter />
        <RelationshipsReportTable />
      </Panel>
    </Page>
  </RelationshipsReportContextContextProvider>
)

export default RelationshipsReport
